const ITEMS = [
  "85% Carne de Pui",
  "Zero Cereale · Grain Free",
  "Dovleac Natural",
  "Taurină Esențială",
  "Borcan din Sticlă 100% Reciclabilă",
  "Fabricat cu Mândrie în România",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-10 font-mono text-[11px] uppercase tracking-[0.32em] text-gold/80 sm:px-14 sm:text-xs">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold/50" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-gold/12 py-6"
      data-testid="brand-marquee"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
}
